import axios from 'axios';
import config from '../../config';
import user from '../user';
import { ERROR_CODE } from './constant';
import { goLogin } from '../utils';
import { message } from 'antd';
import { Response } from './types';
import { newAxiosRequestConfig } from 'libs/HTTP/types';
const axiosInstance = axios.create({
    baseURL: config.API_URL,
    timeout: 30000,
    headers: { 'x-header-tid': 1 }
});
const refreshToken = async () => {
    const res: Response<any> = await axiosInstance.post(
        `/common-auth-server/api/b/auth/token/refresh`
    );
    return res;
};
let isRefreshing = false;
let requests: any[] = [];
// 处理responseType是blob类型的响应
const interceptorsResponse = (response: any) => {
    const contentType = 'text/plain;charset=UTF-8';
    const responseType = 'blob';
    const { data } = response;
    if (
        typeof response.request.responseType === 'string' &&
        response.request.responseType.toLocaleLowerCase() === responseType
    ) {
        if (response.headers['content-type'] === contentType) {
            let reader: any = new FileReader();
            reader.readAsText(data);
            return new Promise(resolve => {
                reader.onload = (e: any) => {
                    resolve(JSON.parse(e.target.result));
                };
            });
        }
    }
    return data;
};
axiosInstance.interceptors.request.use(
    function (config) {
        config.headers['x-header-token'] = user.getToken();
        return config;
    },
    function (error) {
        return Promise.reject(error);
    }
);
axiosInstance.interceptors.response.use(
    async function (response) {
        const { data, config } = response;
        const { code, success } = await interceptorsResponse(response);
        if (
            code === ERROR_CODE.INVALID_TOKEN ||
            code === ERROR_CODE.NEED_LOGIN
        ) {
            goLogin();
            return data;
        }
        if (code === ERROR_CODE.TOKEN_EXPIRED) {
            if (isRefreshing) {
                return new Promise(resolve => {
                    requests.push(() => {
                        config.headers['x-header-token'] = user.getToken();
                        resolve(axiosInstance(config));
                    });
                });
            } else {
                isRefreshing = true;
                const res = await refreshToken();
                const { data, success } = res;
                isRefreshing = false;
                if (success) {
                    user.setToken(data);
                    requests.forEach(cb => cb());
                    requests = [];
                    return axiosInstance(config);
                } else {
                    user.removeToken();
                    goLogin();
                }
                requests = [];
                return res;
            }
        }
        if (success === false && !(config as newAxiosRequestConfig).hideMsg) {
            let errorMessage = data.message;
            message.error(errorMessage);
        }
        return data;
    },
    function (error) {
        return {
            success: false
        };
    }
);
export default axiosInstance;
